<template>
    <div class="bi-com bi-input font-prompt">
        <!-- <label class="bi-lbl"
            :for="id">{{label}} <span class="require-mark" v-if="isRequireField">*</span></label> -->
        <div class="bi-wrapper">
            <input type="text"
                :id="id"
                class="input-icon-user"
                :class="{'bi-error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                :maxlength="maxLength"
                :placeholder="label"
                v-model="content"
                @focus="tackBzb()"
                @change="onChange()" />
            <!-- <span class="bi-placeholder"
                :class="{'bi-placeholder-error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                v-show="!content">{{placeholder}}</span> -->
        </div>
        <div class="bi-lbl-error"
            v-if="isShowErrorLbl"
            v-show="!isFirstSave && !errorInfo.isValid">{{errorInfo.msg}}</div>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
/**
 * Property
 * @property {string} inputId (required) Field id for emit.
 * @property {object} inputLbl (required) Text for component.
 * @property {number} inputMinLength (optional) Minimum length.
 * @property {number} inputMaxLength (optional) Maximum Length.
 * @property {boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {object} errorInfo (optional) Validate result
 * @property {boolean} isTextOnly (optional) Only text.
 * @property {boolean} thaiOnly (optional)
 * @property {boolean} englishOnly (optional)
 * Event
 * @event onChange Filter and validate.
 * Method
 * @method validateInput Validate text.
 */
export default {
    name: 'TextInput',
    props: {
        //v-model
        value: String,
        //props
        inputId: String,
        inputLbl: Object,
        inputMinLength: Number,
        inputMaxLength: Number,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        isTextOnly: Boolean,
        thaiOnly: Boolean,
        englishOnly: Boolean,
        event: String,
        category: String
    },
    data: function () {
        return {
            id: '',
            label: '',
            placeholder: '',
            content: this.value,
            minLength: 0,
            maxLength: 0,

            isRequireField: false,
            tracking: new TrackingService(this),
        };
    },
    mounted: function () {
        
        this.id = this.inputId;
        this.label = this.inputLbl.name || 'Label';
        this.placeholder = this.inputLbl.placeholder || '';
        this.minLength = this.inputMinLength || null;
        this.maxLength = this.inputMaxLength || null;
        
        this.isRequireField = !Util.isEmptyStr(this.inputLbl.required);
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            
            if(!this.inputLbl) return;
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Required
            if(this.inputLbl.required
                && !this.content) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
            //Too short
            if(this.inputLbl.too_short && this.minLength
                && (this.content.length < this.minLength)) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = Util.stringFormat(this.inputLbl.too_short, this.minLength);
                return;
            }
            //InValid format
            if(this.inputLbl.invalid) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.invalid;
                return;
            }
        },
        onChange: function () {
            var result = this.content;
            //Remove restrict character.
            result = result.replace(Vue.RegExp.emoji, '');
            
            if(this.isTextOnly) {
                result = result.replace(Vue.RegExp.number, '');
                result = result.replace(Vue.RegExp.symbol, '')
            }

            if (this.thaiOnly) {
                result = result.replace(/[^\u0E01-\u0E3A\u0E3F-\u0E4D\u0E50-\u0E5A\s]/g, '');
            }

            if (this.englishOnly) {
                result = result.replace(/[^a-zA-Z\s]/g, '');
            }

            this.content = result;
            this.validateInput();
            this.$emit('input', result);
        },
        tackBzb: function () {
            
            this.tracking.event(this.category, this.event);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/component/baseinput.scss";

.input-icon-user {
    @extend %input-base-custom;
    font-size: 0.9rem;
    // background-image: url('../../../assets/img/icon_user.png');
}
</style>
